<template>
  <div>
    <div>
      <el-checkbox-group v-model="catalog">
        <el-checkbox
          v-for="item in catalogs"
          :key="`value-catalog-${item.value}`"
          :label="item.value"
        >
          {{ item.text }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div style="padding-top: 10px;">
      <el-checkbox-group v-model="type">
        <el-checkbox
          v-for="item in types"
          :key="`value-type-${item.value}`"
          :label="item.value"
        >
          {{ item.text }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
import { Checkbox, CheckboxGroup } from "element-ui";
import {
  schema,
  findCatalog,
  findTypes,
  findValue,
} from "../../../schema/label/type";

const toArray = (value) => {
  if (value === undefined || value === null) {
    return [];
  }
  return [value];
};
const obtainNewItems = (oldArray, newArray) => {
  if (!Array.isArray(oldArray) || !oldArray.length) {
    return Array.isArray(newArray) ? newArray : [];
  }
  if (!Array.isArray(newArray)) {
    return [];
  }
  if (!newArray) {
    return newArray;
  }
  return newArray.filter((current) => !oldArray.includes(current));
};
/**
 * 填写类型 选择器
 */
export default {
  name: "value-type-selector",
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  props: {
    value: {
      type: Number,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    catalog: {
      get() {
        const { value } = this.$props;
        const obj = findCatalog(value);
        if (obj === undefined) {
          return [];
        }
        return toArray(obj.value);
      },
      set(value) {
        const catalog = obtainNewItems(this.catalog, value);
        if (!catalog.length) {
          this.emitChange(null);
          return;
        }
        const newType = findValue(catalog[0], this.$props.value);
        this.emitChange(newType);
      },
    },
    type: {
      get() {
        const { value } = this.$props;
        return toArray(value);
      },
      set(value) {
        console.log(value);
        const items = obtainNewItems(this.type, value);
        if (items.length) {
          this.emitChange(items[0]);
          return;
        }
        if (!this.catalog.length) {
          this.emitChange(null);
          return;
        }
        const newType = findValue(this.catalog[0]);
        this.emitChange(newType);
      },
    },
  },
  data() {
    const catalogs = schema.map(({ value, text }) => ({ value, text }));
    return {
      catalogs,
      types: [],
    };
  },
  watch: {
    catalog(value) {
      this.types = findTypes(value);
    },
  },
  methods: {
    emitChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>
